<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>
    

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ formatInteger(objEdicao.cdtpdoc) }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption" for="nmtpdoc">Nome/Descrição</label>
                <input type="text" v-model="objEdicao.nmtpdoc" id="nmtpdoc" maxlength="100" v-uppercase />
            </div>
            
            <div class="form-item-char40">
                <TpDocGrupoSelect v-model:idSelecionado="objEdicao.idtpdocgrupo" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="detalhamento">Detalhamento</label>
                <textarea v-model="objEdicao.detalhamento" id="detalhamento" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>

        <div class="row-end">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <label for="ckObrigatorio">Documento obrigatório</label>
            <input type="checkbox" class="input-checkbox" id="ckObrigatorio" v-model="ckObrigatorio" />
        </div>

        <div class="row-end">
            <label for="ckValidade">Informar Data de Validade</label>
            <input type="checkbox" class="input-checkbox" id="ckValidade" v-model="ckValidade" />
        </div>

        <div class="row-end row-space">
            <label for="ckVerificacao">Necessário Verificação/Aprovação do Fiscal</label>
            <input type="checkbox" class="input-checkbox" id="ckVerificacao" v-model="ckVerificacao" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarTpDoc } from '@/models/tpdoc';
import { formatInteger } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import TpDocGrupoSelect from '@/components/selects/TpDocGrupoSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const ckObrigatorio = ref(false);
const ckValidade = ref(false);
const ckVerificacao = ref(false);
const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarTpDoc());

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('tpdoc', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }
        objEdicao.value.idusuario       = globalStore.idusuario;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';        
        ckObrigatorio.value             = objEdicao.value.ckobrigatorio === 'S';        
        ckValidade.value                = objEdicao.value.ckvalidade === 'S';        
        ckVerificacao.value             = objEdicao.value.ckverificacao === 'S';        
    } catch (error) {msgAlerta.value = error;
    }finally{isLoading.value=false;}
};

async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;
        objEdicao.value.ativo           = ckAtivo.value ? 'S' : 'N';
        objEdicao.value.ckobrigatorio   = ckObrigatorio.value ? 'S' : 'N';
        objEdicao.value.ckvalidade      = ckValidade.value ? 'S' : 'N';
        objEdicao.value.ckverificacao   = ckVerificacao.value ? 'S' : 'N';
        const response                  = await genericPut('/cad/tpdoc', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error) {msgAlerta.value = error;
    } finally{isLoading.value=false;}
}
function validarDados(){
    let r = Validar.texto(objEdicao.value.nmtpdoc, 'Informe nome do tipo de documento');
    if (!r.ok) return r.msg;
    if (!objEdicao.value.idtpdocgrupo) return 'Informe o grupo';
    return null;
}

onMounted(lerDados);
</script>